import script from "./demo-day-mobile-blurred-company-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-day-mobile-blurred-company-tabs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__